export default __webpack_public_path__ + "static/media/MN25_logo_cores.8c26551c.svg";